import formats from '../../api/formats'
import dialogs from '../common/dialogs.js'
import store from '../../store'
import AssistClasses from '../assist/AssistClasses.js'
// import client from '../client'

class Strategy extends AssistClasses.Strategy {
  constructor (cxt) {
    super(cxt)
    this.chipsItems = []
    this.pProps = null
  }
  getTypeCode () {
    return 'COMPANY_BANK'
  }
  getTypeName () {
    return 'Банковские реквизиты'
  }
  setContext (cxt) {
    this.context = cxt
  }
  setParentProps (pProps) {
    this.pProps = pProps
  }
  createModel () {
    var model = new Model()
    return model
  }
  createModelFromJSON (json) {
    return Object.assign(this.createModel(), JSON.parse(json))
  }
  createDefaultModel (parent) {
    return Object.assign(this.createModel(), {})
  }
  createModelFromData (data) {
    return Object.assign(this.createModel(), data)
  }
  updateSteps (scheme) {
    const bankAccountRules = v => !v || formats.isBankAccount(v) || 'Неверный формат банковского счета'
    const bankRcbicRules = v => !v || formats.isBankRcbic(v) || 'Неверный формат БИК банка'

    let steps = []

    new AssistClasses.Step(
      '',
      (step) => {},
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Название',
            hint: 'Используется для поиска значения по умолчанию, первый элемент в обратном порядке',
            name: 'name',
            grow: true,
            size: {sm8: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Расчетный счет',
            name: 'bankAccount',
            rules: Array.of(bankAccountRules),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Название банка',
            name: 'bankName',
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Корреспондентский счет',
            name: 'bankCorrAccount',
            rules: Array.of(bankAccountRules),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'БИК',
            name: 'bankRcbic',
            rules: Array.of(bankRcbicRules),
            grow: true,
            size: {sm6: true, xs6: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Адрес банка',
            name: 'bankAddress',
            grow: true,
            size: {sm12: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Примечание',
            name: 'notes',
            grow: true,
            size: {sm12: true, xs12: true}
          }
        ]
      },
      {
      }).addToArray(steps)

    this.steps = steps
    return this
  }
  viewNumber (model) {
    return model['name'] ? model['name'] : '-'
  }
  viewTitle (model) {
    if (this.parent) {
      return `Банковские реквизиты ${this.pProps.companyNameShort}`
    }
    return this.getTypeName()
  }
  viewTitleComp (model) {
    return formats.createComp(`
      <span>${model['name'] ? model['name'] : this.getTypeName()}</span>
    `)
  }
  viewContentComp (model) {
    const _f = (v) => v || '-'
    let value = this.viewContent(model)
    let caption = `
      <span>
        <span>Р/с: <b>${_f(model['bankAccount'])}</b></span>
        <span>в <b>${_f(model['bankName'])}</b></span>
        <span>К/с: <b>${_f(model['bankCorrAccount'])}</b></span>
        <span>БИК: <b>${_f(model['bankRcbic'])}</b></span>
      </span>
    `
    return {
      template: `<span><component :is="renderValueLink()"></component></span>`,
      methods: {
        renderValueLink () {
          return store.getters.renderValueLink(value, null, null, null, caption)
        }
      }
    }
  }
  viewContent (model) {
    const _f = (v) => v || '-'
    return `
        Р/с: ${_f(model['bankAccount'])}
        в ${_f(model['bankName'])}
        К/с: ${_f(model['bankCorrAccount'])}
        БИК: ${_f(model['bankRcbic'])}
    `
  }
  updateModel (model) {
    this.steps.forEach((step) => step.setModel(model))
  }
  fetchData (itemId) {
    return new Promise((resolve, reject) => {
      if (itemId) {
        this.context.$store.dispatch('getCompanyBank', itemId).then(data => resolve(data))
      } else {
        resolve(null)
      }
    })
  }
  updateData (itemId, model, parentId) {
    let item = model
    item['id'] = itemId
    if (this.pProps) {
      item['clientCompanyId'] = this.pProps.clientCompanyId
    }
    return new Promise((resolve, reject) => {
      this.context.$store.dispatch('updateCompanyBank', {dto: item}).then(id => {
        resolve(id)
      })
    })
  }
  deleteData (itemId, model) {
    return new Promise((resolve, reject) => {
      dialogs.confirm(this.context,
        'Подтвердите',
        `Удалить запись о банке?`,
          (self) => {
            self.$store.dispatch('deleteCompanyBank', {ids: [itemId]})
              .then(() => resolve())
          })
    })
  }
}

class Model {
  constructor () {
    this.modelType = '212.01'
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/favorite/companyBank.js